import { number } from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Col,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  ModalFooter,
  Label,
  Input,
} from 'reactstrap';
import { streetDirOptions } from '../constant';
function Listing({ allNumbers, numbers, setNumbers, data, setData, LISTING_FORM }) {
  const stateCodes = useSelector(state => state.UIState.proposalEditor.stateCodes);
  const onChangeText = (value, index, key) => {
    let temp = [...data];
    temp[index][key] = value;
    setData(temp);
  };
  const onRemove = idx => {
    let temp = [...data];
    temp = temp.slice(idx, idx + 1);
    setData([...temp]);
    onSettingNumbers(temp);
  };
  const onNumberSelect = (selectedNumbers, index) => {
    let temp = [...data];
    temp[index].selectedNumbers = [...selectedNumbers];
    setData(temp);
    onSettingNumbers(temp);
  };
  const onSettingNumbers = (temp = data) => {
    let newNumbers = allNumbers.filter(num => !temp.some(obj => obj.selectedNumbers.includes(num)));
    setNumbers(newNumbers);
  };
  const onSelectAll = index => {
    let temp = [...data];
    temp[index].selectedNumbers = [...temp[index].selectedNumbers, ...numbers];
    setData(temp);
    onSettingNumbers(temp);
  };
  const onUnSelectAll = index => {
    let temp = [...data];
    temp[index].selectedNumbers = [];
    setData(temp);
    onSettingNumbers(temp);
  };
  let buttonUsed = numbers.length - (allNumbers.length === numbers.length ? 1 : 0);

  return (
    <div className="p-4">
      {data.map((item, index) => {
        return (
          <div key={index}>
            <Row>
              {index > 0 && (
                <Col md={{ offset: 11 }}>
                  <div onClick={() => onRemove(index)} className="arrow-icon">
                    <i className="fas fa-times" />
                  </div>
                </Col>
              )}
            </Row>
            <Row>
              <Col sm={3}>
                <Label>Last/Business Name</Label>
                <Input
                  placeholder="Last/Business Name"
                  type="text"
                  className="error-control"
                  name={'businessName' + index}
                  id={'businessName' + index}
                  value={item.businessName}
                  onChange={e => onChangeText(e.target.value, index, 'businessName')}
                />
              </Col>
              <Col sm={3}>
                        <Label>First Name</Label>
                <Input
                  placeholder="FirstName Name"
                  type="text"
                  name={'firstName' + index}
                  id={'firstName' + index}
                  value={item.firstName}
                  onChange={e => onChangeText(e.target.value, index, 'firstName')}
                />
              </Col>
              <Col sm={3}>
                <Label>Street Number</Label>
                <Input
                  placeholder="Street Number"
                  type="text"
                  name={'streetNo' + index}
                  id={'streetNo' + index}
                  value={item.streetNo}
                  onChange={e => onChangeText(e.target.value, index, 'streetNo')}
                />
              </Col>
              <Col sm={3}>
                <Label>Street Pre-Direction</Label>
                <select
                  className="form-control"
                  onChange={evt => onChangeText(evt.target.value, index, 'streetPreDirection')}
                  name={'streetPreDirection' + index}
                  id={'streetPreDirection' + index}
                  defaultValue={item.streetPreDirection}
                >
                  <option value="">Select Any</option>
                  {streetDirOptions.map(({ value, text, disabled }) => (
                    <option disabled={disabled} key={value} value={value}>
                      {text}
                    </option>
                  ))}
                </select>
              </Col>
              <Col sm={3}>
                <Label>Street Name</Label>
                <Input
                  placeholder="Street Name"
                  type="text"
                  name={'streetName' + index}
                  id={'streetName' + index}
                  value={item.streetName}
                  onChange={e => onChangeText(e.target.value, index, 'streetName')}
                />
              </Col>
              <Col sm={3}>
                <Label>Street Type</Label>
                <Input
                  placeholder="Street Type"
                  type="text"
                  name={'streetType' + index}
                  id={'streetType' + index}
                  value={item.streetType}
                  onChange={e => onChangeText(e.target.value, index, 'streetType')}
                />
              </Col>
              <Col sm={3}>
                <Label>Street Post-Direction</Label>
                <select
                  className="form-control"
                  onChange={evt => onChangeText(evt.target.value, index, 'streetPostDirection')}
                  name={'streetPostDirection' + index}
                  id={'streetPostDirection' + index}
                  defaultValue={item.streetPostDirection}
                >
                  <option value="">Select Any</option>
                  {streetDirOptions.map(({ value, text, disabled }) => (
                    <option disabled={disabled} key={value} value={value}>
                      {text}
                    </option>
                  ))}
                </select>
              </Col>
              <Col sm={3}>
                <Label>Location</Label>
                <Input
                  placeholder="Location"
                  type="text"
                  name={'location' + index}
                  id={'location' + index}
                  value={item.location}
                  onChange={e => onChangeText(e.target.value, index, 'location')}
                />
              </Col>
              <Col sm={3}>
                <Label>City</Label>
                <Input
                  placeholder="City"
                  type="text"
                  name={'city' + index}
                  id={'city' + index}
                  value={item.city}
                  onChange={e => onChangeText(e.target.value, index, 'city')}
                />
              </Col>
              <Col sm={3}>
                <Label>State</Label>
                <select
                  className="form-control"
                  name={'state' + index}
                  id={'state' + index}
                  defaultValue={item.state}
                  type="text"
                  onChange={e => onChangeText(e.target.value, index, 'state')}
                >
                  <option value="">Select Any</option>
                  {stateCodes.map(state => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </Col>

              <Col sm={3}>
                <Label>Zip Code</Label>
                <Input
                  placeholder="Zip Code"
                  type="text"
                  name={'zip' + index}
                  id={'zip' + index}
                  value={item.zip}
                  onChange={e => onChangeText(e.target.value, index, 'zip')}
                />
              </Col>
            </Row>
            <p style={{ marginTop: 10 }}>
              In box below, click to select Telephone Numbers targeted by data above.
              <br />
              To multi-select, click and drag across numbers, or use Shift or Ctrl
            </p>
            <Col md={3}>
              <div className="d-flex justify-content-between align-items-center w-100">
                <Button outline color="primary" onClick={() => onSelectAll(index)}>
                  Select All
                </Button>
                <Button outline color="primary" onClick={() => onUnSelectAll(index)}>
                  Unselect All
                </Button>
              </div>
              <select
                value={item.selectedNumbers}
                id={'selectedNumbers' + index}
                name={'selectedNumbers' + index}
                onChange={e =>
                  onNumberSelect(
                    Object.values(e.target.selectedOptions).map(item => item.value),
                    index,
                  )
                }
                multiple={true}
                style={{ width: '100%', height: 100, marginTop: 30 }}
              >
                {item.selectedNumbers.map(number => (
                  <option key={number} value={number} label={number} />
                ))}
                {numbers.map(number => (
                  <option key={number} value={number} label={number} />
                ))}
              </select>
            </Col>
          </div>
        );
      })}
      {buttonUsed > 0 && (
        <>
          <div className="d-flex" style={{ marginTop: 10 }}>
            <h2>Add Different Features To Remaining Numbers?</h2>&nbsp;
            <p>{`(You can use this button ${buttonUsed} more ${
              buttonUsed > 1 ? 'times' : 'time'
            })`}</p>
          </div>
          <Button
            outline
            color="primary"
            style={{ marginTop: 10 }}
            onClick={() => setData([...data, { ...LISTING_FORM }])}
          >
            Add
          </Button>
        </>
      )}
    </div>
  );
}

export default Listing;
